namespace Matrix.Indexation {
    export namespace IndexationProfileSecurityService {
        export const baseUrl = 'Indexation/IndexationProfileSecurity';

        export declare function Create(request: Serenity.SaveRequest<IndexationProfileSecurityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IndexationProfileSecurityRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IndexationProfileSecurityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IndexationProfileSecurityRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Indexation/IndexationProfileSecurity/Create",
            Update = "Indexation/IndexationProfileSecurity/Update",
            Delete = "Indexation/IndexationProfileSecurity/Delete",
            Retrieve = "Indexation/IndexationProfileSecurity/Retrieve",
            List = "Indexation/IndexationProfileSecurity/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IndexationProfileSecurityService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
